
					const modules = import.meta.glob([
  "/mock/account.ts",
  "/mock/asyncRoutes.ts",
  "/mock/login.ts",
  "/mock/process.ts",
  "/mock/refreshToken.ts",
  "/mock/system.ts"
], { eager: true });
					const fakeModuleList = Object.keys(modules).reduce((list, key) => {
						const module = modules[key] ?? {};
						if (module.default) {
							for (const moduleKey of Object.keys(module)) {
								const mod = modules[key][moduleKey] ?? [];
								const modList = Array.isArray(mod) ? [...mod] : [mod];
								return [...list, ...modList];
							}
						} else {
							return list;
						}
					}, []);
					window.__VITE__PLUGIN__FAKE__SERVER__.fakeModuleList = fakeModuleList;
				